(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vnm-addon"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const check = el.querySelector('[data-addon-check]'), status = el.querySelector('[data-addon-status]');
      const hostId = String(el.dataset.hostId), variantId = el.dataset.variantId, title = el.dataset.addonTitle;
      let busy = false;
      document.addEventListener('cart:update', async (e) => {
        const d = (e.detail && e.detail.data) || {};
        if (d.source !== 'product-form-component' || String(d.productId) !== hostId || d.didError || !check.checked || busy) return;
        busy = true;
        try {
          const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean).join(',');
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections }) });
          const json = await res.json();
          if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add');
          const cart = await fetch('/cart.js').then((r) => r.json()).catch(() => undefined);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'vnm-addon', data: { source: 'vnm-addon', itemCount: 1, productId: json.product_id, sections: json.sections } } }));
          status.textContent = title + ' added to your cart too.'; status.hidden = false;
          setTimeout(() => { status.hidden = true; }, 6000);
        } catch (err) {
          status.textContent = 'Could not add ' + title + ' — you can add it from its own page.'; status.hidden = false;
        } finally { busy = false; }
      });
    };
    const boot = () => document.querySelectorAll('[data-vnm-addon]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
